import { render, staticRenderFns } from "./EleImportUpload.vue?vue&type=template&id=70547b71&"
import script from "./EleImportUpload.vue?vue&type=script&lang=js&"
export * from "./EleImportUpload.vue?vue&type=script&lang=js&"
import style0 from "./EleImportUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports